// extracted by mini-css-extract-plugin
module.exports = {"unavailableWidgetContainer":"unavailable-widget-container__2-c4q","unavailableWidget":"unavailable-widget__2vd5l","unavailableWidgetText":"unavailable-widget-text__34692"};